import { gql } from '@apollo/client';

export const GET_HEATMAP_INSIGHTS = gql`
  query getHeatMapInsightsV2($dataScope: DataScope!, $locationId: ID!, $startAt: ISO8601DateTime!, $endAt: ISO8601DateTime!) {
    heatMapInsightsV2(dataScope: $dataScope, locationId: $locationId, startAt: $startAt, endAt: $endAt) {
      date
      part
      sum
    }
  }
`;
